// removed by extract-text-webpack-plugin
module.exports = {"table":"general__table___3jJCK display-table height-100 width-100","tableS":"general__tableS___2_zai breakPointS-display-table breakPointS-height-100 breakPointS-width-100","tableM":"general__tableM___2XlIT breakPointM-display-table breakPointM-height-100 breakPointM-width-100","tableL":"general__tableL___1DXwW breakPointL-display-table breakPointL-height-100 breakPointL-width-100"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-align/Align/style/general.css
// module id = 78
// module chunks = 0 16